import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import './assets/fonts/iconfont/iconfont.css'
// Vue.use(VueRouter)
import routes from './router.js'
import store from './vuex/store'
import axios from 'axios'
import QRCode from 'qrcodejs2'
import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs;

Vue.prototype.QRCode = QRCode

// const router = new VueRouter({
//   routes
// })

import hls from 'videojs-contrib-hls'
import VideoPlayer from 'vue-video-player';
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"

Vue.use(hls)
Vue.use(VideoPlayer)


import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)


// import Api from './http/index'
// Vue.use(Api)
import Api from './config/api/index'
window.Api = Api

import Common from "./config/utils/common"
window.Common = Common

//定义公共组件
import footer from './views/common/footer.vue'

//定义公共组件
import team from './views/common/team.vue'
import empty from './views/common/empty.vue'
Vue.component('footer-view',footer)
Vue.component('team-view',team)
Vue.component('empty',empty)

// import header_black from './views/common/header_black.vue'
// Vue.component('headerBlack-view',header_black)
// import header_white from './views/common/header_white.vue'
// Vue.component('headerWhite-view',header_white)

//公共组件
import CommonMComs from './common/src'
Vue.use(CommonMComs)  

import Cookies from 'js-cookie'
// import login from './vuex/modules/login'
// 配置成全局使用
window.Cookies = Cookies
Cookies.get = Cookies.getJSON

Vue.config.productionTip = false

// Vue.prototype.imageURL = 'http://test.cnuen.net:10180/platform/files'
Vue.prototype.imageURL = 'https://syq.lezhireading.com/platform/files'
// Vue.prototype.imageURL = 'http://192.168.1.58:11081/platform/files'


Vue.prototype.handleTimeOne = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[0]+"-" + timearr[1] + "-" + timearr[2]
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},


Vue.prototype.handleTimeTwo = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[0]+"." + timearr[1]
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},
Vue.prototype.handleTimeTwos = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[0]+"/" + timearr[1]
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},
Vue.prototype.handleTimeThree = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[1]
  // console.log(timestr);
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},
Vue.prototype.handleTimeFour = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[2]
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},
Vue.prototype.handleTimeFive = function (times){
  var timearr = (times+'').replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = ""+timearr[1]+"." + timearr[2]
  //var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t" + timearr[3] + ":" + timearr[4] + ""
  return timestr
},


Vue.prototype.urlEncode = function objectToQueryString(obj) {
  return Object.keys(obj).map(function (key) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
  }).join('&');
};


Vue.use(VueRouter)
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // console.log('to.meta.id',to.meta.id);
  // sessionStorage.setItem('isActive', to.meta.id) 
  // store.commit('addcount',to.meta.id)
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
